import React from 'react';
import { Link } from 'react-router-dom';
import "../../styles/Auth/NotFound.css";

const NotFoundPage = () => {
  return (
    <div className="notfound-container">
      <div className="notfound-box">
        <h1 className="notfound-title">404</h1>
        <p className="notfound-message">Oops! The page you're looking for doesn't exist.</p>
        <Link to="/login" className="notfound-button">Go to Login</Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
